import request from '@host-panel/request';

export default payload => {
  return request('/host-panel/reactions/spot_config', {
    method: 'PUT',
    data: payload
  });
};
